import { LngLatBounds } from 'mapbox-gl';
import { Coordinates } from 'viewport-mercator-project';

import { Theme } from '@routific/hive';

export const positionIsInBounds = (bounds: LngLatBounds, targetLngLat: Coordinates) => bounds.contains(targetLngLat);

const isPositionBehindLeftTray = (
  x: number,
  isLeftPanelOpen: boolean,
  leftPanelWidth: number,
) => !!isLeftPanelOpen && (x < leftPanelWidth);

const isPositionBehindRightTray = (
  x: number,
  isRightPanelOpen: boolean,
  mapWidth: number,
  rightPanelWidth: number,
) => isRightPanelOpen && (x > (mapWidth - rightPanelWidth));

const isPositionBehindBottomTray = (
  y: number,
  isBottomPanelOpen: boolean,
  mapHeight: number,
  bottomPanelHeight: number,
) => isBottomPanelOpen && (y > (mapHeight - (bottomPanelHeight + parseInt(Theme.Spacing.mdSpacing, 10))));

export interface ViewportPosition {
  bounds: LngLatBounds,
  coordinates: Coordinates,
  position: Coordinates,
  mapWidth: number,
  mapHeight: number,
  isLeftPanelOpen?: boolean,
  isRightPanelOpen?: boolean,
  isBottomPanelOpen?: boolean,
  leftPanelWidth: number,
  rightPanelWidth: number,
  bottomPanelHeight: number,
}

export const isPositionInViewingArea = ({
  bounds,
  coordinates,
  position,
  mapWidth,
  mapHeight,
  isLeftPanelOpen = false,
  isRightPanelOpen = false,
  isBottomPanelOpen = false,
  leftPanelWidth,
  rightPanelWidth,
  bottomPanelHeight,
}: ViewportPosition): boolean => {
  if (!positionIsInBounds(bounds, coordinates)) {
    return false;
  }

  const [x, y] = position;

  if (isPositionBehindLeftTray(x, isLeftPanelOpen, leftPanelWidth)) {
    return false;
  }

  if (isPositionBehindRightTray(x, isRightPanelOpen, mapWidth, rightPanelWidth)) {
    return false;
  }

  if (isPositionBehindBottomTray(y, isBottomPanelOpen, mapHeight, bottomPanelHeight)) {
    return false;
  }

  return true;
};
